export const announcementByTenantLandscapeWithConnection = /* GraphQL */ `
  query AnnouncementByTenantLandscape(
    $tenantLandscape: String
    $sortDirection: ModelSortDirection
    $filter: ModelAnnouncementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    announcementByTenantLandscape(
      tenantLandscape: $tenantLandscape
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenant
        landscape
        tenantLandscape
        users {
          nextToken
        }
        title
        content
        linkToProductMenu
        isPublic
        displayStartDate
        displayEndDate
        priorityTag
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
